module.exports = __webpack_public_path__ + "media/hyper/fonts/unicons-257bdf01db318b704dd641dc18376aff.ttf";